var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFiEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.99981C17.2626 2.73717 17.5744 2.52883 17.9176 2.38669C18.2608 2.24455 18.6286 2.17139 19 2.17139C19.3714 2.17139 19.7392 2.24455 20.0824 2.38669C20.4256 2.52883 20.7374 2.73717 21 2.99981C21.2626 3.26246 21.471 3.57426 21.6131 3.91742C21.7553 4.26058 21.8284 4.62838 21.8284 4.99981C21.8284 5.37125 21.7553 5.73905 21.6131 6.08221C21.471 6.42537 21.2626 6.73717 21 6.99981L7.5 20.4998L2 21.9998L3.5 16.4998L17 2.99981Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiEdit);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDIuOTk5ODFDMTcuMjYyNiAyLjczNzE3IDE3LjU3NDQgMi41Mjg4MyAxNy45MTc2IDIuMzg2NjlDMTguMjYwOCAyLjI0NDU1IDE4LjYyODYgMi4xNzEzOSAxOSAyLjE3MTM5QzE5LjM3MTQgMi4xNzEzOSAxOS43MzkyIDIuMjQ0NTUgMjAuMDgyNCAyLjM4NjY5QzIwLjQyNTYgMi41Mjg4MyAyMC43Mzc0IDIuNzM3MTcgMjEgMi45OTk4MUMyMS4yNjI2IDMuMjYyNDYgMjEuNDcxIDMuNTc0MjYgMjEuNjEzMSAzLjkxNzQyQzIxLjc1NTMgNC4yNjA1OCAyMS44Mjg0IDQuNjI4MzggMjEuODI4NCA0Ljk5OTgxQzIxLjgyODQgNS4zNzEyNSAyMS43NTUzIDUuNzM5MDUgMjEuNjEzMSA2LjA4MjIxQzIxLjQ3MSA2LjQyNTM3IDIxLjI2MjYgNi43MzcxNyAyMSA2Ljk5OTgxTDcuNSAyMC40OTk4TDIgMjEuOTk5OEwzLjUgMTYuNDk5OEwxNyAyLjk5OTgxWiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };